import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-reference-scheme-router',
  templateUrl: './reference-scheme-router.component.html',
  imports: [RouterOutlet],
})
export class ReferenceSchemeRouterComponent {}
